export const Status = Object.freeze({
  ACCEPTED: "accepted",
  ACTIVE: "active",
  ALL: "all",
  APPROVED: "approved",
  AWAITING_BALANCE: "awaitingBalance",
  AWAITING_PAYMENT: "awaitingPayment",
  AWAITING_STOCK: "awaitingStock",
  B2B_REJECTED: "b2bRejected",
  BALANCE_UNDER_REVIEW: "balanceUnderReview",
  CANCELLED: "cancelled",
  COMPLETED: "completed",
  CONVERTED: "converted",
  CUSTOM: "custom",
  DEBUG: "debug",
  DECLINED: "declined",
  DEGRADED: "degraded",
  DELETE: "delete",
  DELIVERED: "delivered",
  DEPOSIT_UNDER_REVIEW: "depositUnderReview",
  DRAFT: "draft",
  ERROR: "error",
  EXPIRED: "expired",
  FAILED: "failed",
  FULFILLED: "fulfilled",
  FULLY_ALLOCATED: "fullyAllocated",
  GROUPED: "grouped",
  HEALTHY: "healthy",
  INACTIVE: "inactive",
  INBOUND: "inbound",
  INFO: "info",
  IN_STOCK: "inStock",
  INVOICED: "invoiced",
  ISSUED: "issued",
  LOADING: "loading",
  OFFLINE: "offline",
  ON_HOLD: "onHold",
  OUTBOUND: "outbound",
  OUT_OF_STOCK: "outOfStock",
  OVERDUE: "overdue",
  PAID: "paid",
  PARTIALLY_ALLOCATED: "partiallyAllocated",
  PARTIALLY_PAID: "partiallyPaid",
  PAYMENT_VERIFIED: "paymentVerified",
  PENDING: "pending",
  PENDING_B2B_APPROVAL: "pendingB2bApproval",
  PENDING_CONSOLIDATED: "pendingConsolidated",
  PENDING_DEPOSIT: "pendingDeposit",
  PENDING_PAYMENT_VERIFICATION: "pendingPaymentVerification",
  PENDING_REVIEW: "pendingReview",
  PENDING_UPLOAD: "pendingUpload",
  PRE_ORDER_CONFIRMED: "preOrderConfirmed",
  PRE_ORDER_CONVERTED: "preOrderConverted",
  PROCESSING: "processing",
  PUBLISH: "publish",
  QUALIFIED: "qualified",
  QUALIFIED_OFFER: "qualifiedOffer",
  QUOTE_DISPATCHED: "quoteDispatched",
  QUOTE_REQUESTED: "quoteRequested",
  REFUNDED: "refunded",
  REJECTED: "rejected",
  RESERVED: "reserved",
  REVOKED: "revoked",
  RMA_RECEIVED: "rmaReceived",
  RMA_REQUESTED: "rmaRequested",
  SETTLED: "settled",
  SHIPPED: "shipped",
  SIMPLE: "simple",
  SUCCEEDED: "succeeded",
  SUCCESS: "success",
  SUSPENDED: "suspended",
  TRASH: "trash",
  UNDER_REVIEW: "underReview",
  UNKNOWN: "unknown",
  UNPAID: "unpaid",
  UNREACHABLE: "unreachable",
  USED: "used",
  VARIABLE: "variable",
  VERIFYING: "verifying",
  WARNING: "warning",
});
